import { render, staticRenderFns } from "./StatementsLayout.vue?vue&type=template&id=7e45ac6f"
import script from "./StatementsLayout.vue?vue&type=script&lang=js"
export * from "./StatementsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports